import Component from './Locations.container';

export default Component;
